import { useTranslation } from 'react-i18next'
import {
  isDashboardBlocked,
  useFeatureFlag
} from '@/application/use-feature-flag'
import { CustomCopies } from '@/ui/components/custom-copies/custom-copies'
import { BlockedDashboardOverlay } from '@/ui/components/overlays/blocked-dashboard-overlay'
import { NavigationTabs, PageHeader } from '@/ui/shared'
import { useCustomisationTabs } from './configuration-tabs'

// useFeatureFlag keeps this in its effect dependencies, so an inline literal would re-evaluate
// the flag — a Flagr call — on every render.
const FLAG_CONTEXT = { pageName: 'configuration' }

function Copies() {
  const { t } = useTranslation()
  const { isFlagEnabled } = useFeatureFlag(isDashboardBlocked, FLAG_CONTEXT)

  const tabs = useCustomisationTabs()

  return (
    <>
      <NavigationTabs tabs={tabs} selectedIndex={1} />
      {isFlagEnabled && <BlockedDashboardOverlay />}
      <PageHeader
        title={t('copies.title')}
        description={t('copies.description')}
      />
      <div className="flex flex-col gap-4 px-7 py-4">
        <CustomCopies />
      </div>
    </>
  )
}

export default Copies
